import React from "react";

import useReveal from "../hooks/useReveal";

/**
 * The shared shell for the Terms and Privacy pages.
 *
 * Both are the same document: a heading, a line of context, then numbered
 * sections that are either a paragraph or a list. Only the words differ, so
 * the markup lives here and each page supplies its own content.
 *
 * `children` covers the one asymmetry — Privacy ends with a contact section
 * containing a mailto link, which is not expressible as plain section data.
 */
function LegalDocument({ id, title, subtitle, sections, children }) {
  useReveal([]);

  return (
    <section className="band light" id={id}>
      <div className="wrap">
        <div className="doc reveal">
          <h2>{title}</h2>
          {subtitle && (
            <p className="sub" style={{ marginBottom: 8 }}>
              {subtitle}
            </p>
          )}

          {sections.map((s) => (
            <section key={s.heading}>
              <h5>{s.heading}</h5>
              <div>
                {s.body && <p>{s.body}</p>}
                {s.list && (
                  <ul>
                    {s.list.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            </section>
          ))}

          {children}
        </div>
      </div>
    </section>
  );
}

export default LegalDocument;
